<div class="confirm-page">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <span class="breadcrumb__item">Home</span>
      <span class="breadcrumb__separator" aria-hidden="true">/</span>
      <span class="breadcrumb__item breadcrumb__item--current" aria-current="page"
        >Reset Password</span
      >
    </nav>
  </header>

  <mat-card class="confirm-card" appearance="outlined">
    <mat-card-content>
      <!-- Token expired -->
      @if (pageState() === 'token_expired') {
        <h1 class="confirm-card__heading confirm-card__heading--error">Link Expired</h1>
        <p class="confirm-card__body">
          This reset link has expired. Reset links are valid for 1 hour.
        </p>
        <button mat-flat-button class="full-width" [routerLink]="['/auth/reset-password']">
          Request New Link
        </button>
      }

      <!-- Invalid token -->
      @if (pageState() === 'invalid_token') {
        <h1 class="confirm-card__heading confirm-card__heading--error">Invalid Link</h1>
        <p class="confirm-card__body">
          This reset link is invalid or has already been used. Please request a new one.
        </p>
        <button mat-flat-button class="full-width" [routerLink]="['/auth/reset-password']">
          Request New Link
        </button>
        <a href="mailto:support@flow.capx.co.za" class="support-link">Contact Support</a>
      }

      <!-- Password form -->
      @if (pageState() === 'form' || pageState() === 'loading') {
        <h1 class="confirm-card__heading">Choose a New Password</h1>
        <p class="confirm-card__body">
          Must be at least 8 characters with 1 uppercase letter and 1 number.
        </p>

        <form class="confirm-form" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
          <div class="field-group">
            <label class="field-label" for="newPassword">New Password</label>
            <mat-form-field appearance="outline" class="full-width">
              <input
                matInput
                class="has-password-toggle"
                id="newPassword"
                [type]="showPassword() ? 'text' : 'password'"
                formControlName="newPassword"
                autocomplete="new-password"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="password-toggle"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
                [attr.aria-pressed]="showPassword()"
              >
                @if (showPassword()) {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"
                    />
                    <path
                      d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"
                    />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                } @else {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                }
              </button>
              <mat-error>
                @if (newPasswordControl.hasError('required')) {
                  Password is required
                } @else if (newPasswordControl.hasError('minLength')) {
                  Must be at least 8 characters
                } @else if (newPasswordControl.hasError('noUppercase')) {
                  Must contain at least 1 uppercase letter
                } @else if (newPasswordControl.hasError('noNumber')) {
                  Must contain at least 1 number
                }
              </mat-error>
            </mat-form-field>
          </div>

          <button
            mat-flat-button
            type="submit"
            class="full-width"
            [disabled]="pageState() === 'loading' || form.invalid"
          >
            @if (pageState() === 'loading') {
              <mat-spinner diameter="20" />
            } @else {
              Reset Password
            }
          </button>
        </form>
      }
    </mat-card-content>
  </mat-card>
</div>
